exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#registerView[data-v-05ab0426]{top:0;bottom:0;overflow-y:auto;overflow-x:hidden;position:fixed;z-index:10002;background:#f5f5f5;width:100%}#registerView .title-box[data-v-05ab0426]{background-color:red}.img[data-v-05ab0426]{width:100%;height:100%;background-size:cover;background-position:50%}.timeDown[data-v-05ab0426]{position:absolute;right:15px;top:15px;background-color:rgba(0,0,0,.4);padding:6px 12px;border-radius:5px;font-size:12px;color:#fff}p[data-v-05ab0426]{padding:100px 0;text-align:center;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-05ab0426","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/RegisterView.vue
// module id = 364
// module chunks = 0